import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  type: 'mongodb',
  name: 'MongoDB',
  category: 'database',
  description: 'Execute operations and manage collections on MongoDB databases',
  icon: 'siMongodb',
  iconType: 'simple-icon',
  color: 'emerald',
  version: '1.0.0',
  credentials: [
    {
      name: 'mongodb',
      required: true,
      displayName: 'MongoDB',
    },
  ],
  tags: ['mongodb', 'nosql', 'database', 'document', 'db'],
  inputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Input',
      required: true,
    },
  ],
  outputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Output',
    },
  ],

  // Tool-capable configuration for AI Agent
  toolCapable: {
    enabled: true,
    name: 'mongodb_database',
    description: 'Execute operations on MongoDB databases. Supports CRUD, aggregation, bulk operations, and collection management (create, drop, info).',
    allowManualDescription: true,
    parameters: {
      operation: {
        toolParamName: 'operation',
        description: 'The operation: find, findOne, insert, update, delete, aggregate, bulkInsert, createCollection, dropCollection, collectionExists, or getCollectionInfo',
        required: true,
        type: 'string',
      },
      database: {
        toolParamName: 'database',
        description: 'The database name to operate on',
        required: false,
        type: 'string',
      },
      collection: {
        toolParamName: 'collection',
        description: 'The collection name to operate on',
        required: true,
        type: 'string',
      },
      sourceArray: {
        toolParamName: 'sourceArray',
        description: 'Source array data for bulkInsert operation',
        required: false,
        type: 'array',
      },
      query: {
        toolParamName: 'query',
        description: 'MongoDB query filter as JSON object',
        required: false,
        type: 'object',
      },
      document: {
        toolParamName: 'document',
        description: 'Document to insert or update data',
        required: false,
        type: 'object',
      },
    },
    outputMapping: {
      documents: 'The query result documents',
      count: 'Number of documents affected or returned',
      success: 'Whether the operation completed successfully',
      exists: 'Whether the collection exists (for collectionExists)',
      info: 'Collection statistics and info (for getCollectionInfo)',
    },
  },
};

export default definition;
